import { jsx as _jsx } from "react/jsx-runtime";
import { queryClient as defaultQueryClient } from '@as-react/common-queries';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
export const WrapWithQueryContext = (BaseComponent, { dehydratedState, queryClient }) => function QueryContextWrapper(props) {
    return (_jsx(QueryClientProvider, { client: queryClient ?? defaultQueryClient, children: _jsx(HydrationBoundary, { state: dehydratedState, children: _jsx(BaseComponent, { ...props }) }) }));
};
